function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" fill="none" viewBox="0 0 14 24">
      <path stroke="#0044F0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M12 22L2 12 12 2"></path>
    </svg>
  );
}

export default Icon;
